import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CodaltComponent } from '../codalt.component';
import { LocalStorage } from '../local-storage.class';
import { AuthService } from '../services/auth/auth.service';
import { AuthorisationService } from '../services/auth/authorisation.service';

@Component({
    selector: 'app-microsoft-callback',
    templateUrl: './microsoft-callback.component.html',
    standalone: false,
})
export class MicrosoftCallbackComponent extends CodaltComponent implements OnInit {
    errorMessage: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit() {
        this.route.queryParams.subscribe(
            (params: { error?: string; code?: string; state?: string; session_state?: string }) =>
                this.subscriptions.add(
                    this.authService.handleMicrosoftCallback(params.code, params.state).subscribe(
                        authResponse => {
                            LocalStorage.setUserToken(authResponse.access_token);
                            this.LocalStorage.setUser(authResponse.user);
                            this.router.navigate(this.postLoginRoute(), { replaceUrl: true });
                        },
                        error => (this.errorMessage = error.message)
                    )
                )
        );
    }

    private postLoginRoute(): string[] {
        if (AuthorisationService.hasFeature(this.Features.CustomersRecentSorted)) {
            return [this.Routenames.customers];
        }

        if (AuthorisationService.hasFunctionality(this.Functionalities.Timeline)) {
            return [this.Routenames.timeline];
        }

        return [this.Routenames.settings];
    }
}
